<template>
    <div>
        <v-snackbar :timeout="callbackResponse.timeout" color="success" top v-model="snackbar">
            {{callbackResponse.message}}
            <v-btn @click="snackbar = false" dark text>Close</v-btn>
        </v-snackbar>
        <v-dialog max-width="500px" v-model="dialogCreate">

            <template v-slot:activator="{ on }">
                <v-btn
                        :success="success"
                        class="mb-2 float-right"
                        color="primary"
                        dark
                        v-on="on"
                >Add Buying Rate
                </v-btn>
            </template>
            <buyingRateForm :success="success" @formResponse="onResponse"/>
        </v-dialog>
        <v-dialog max-width="500px" v-model="dialogEdit">
            <editbuyingRateForm
                    :serviceID="editedData.serviceID"
                    :success="success"
                    @formResponse="onResponse"
                    v-if="dialogEdit"
            />
        </v-dialog>
        <v-dialog max-width="500px" v-model="dialogDelete">
            <deleteListData :deleteFormData="deleteFormData" @formResponse="onResponse"></deleteListData>
        </v-dialog>
        <!--        <v-expansion-panels hover>-->
        <!--            <v-expansion-panel>-->
        <!--                <v-expansion-panel-header>Filter</v-expansion-panel-header>-->
        <!--                <v-expansion-panel-content>-->
        <!--                    <v-container fluid>-->
        <!--                        &lt;!&ndash;            <v-row align="start">&ndash;&gt;-->
        <!--                        &lt;!&ndash;              <v-col class="float-right" cols="12" sm="6">&ndash;&gt;-->
        <!--                        &lt;!&ndash;                <v-select&ndash;&gt;-->
        <!--                        &lt;!&ndash;                  v-model="editedData.provinceId"&ndash;&gt;-->
        <!--                        &lt;!&ndash;                  :items="province"&ndash;&gt;-->
        <!--                        &lt;!&ndash;                  label="Select Province"&ndash;&gt;-->
        <!--                        &lt;!&ndash;                  item-value="id"&ndash;&gt;-->
        <!--                        &lt;!&ndash;                  item-text="value"&ndash;&gt;-->
        <!--                        &lt;!&ndash;                ></v-select>&ndash;&gt;-->
        <!--                        &lt;!&ndash;              </v-col>&ndash;&gt;-->
        <!--                        &lt;!&ndash;              <v-col class="float-right" cols="12" sm="6">&ndash;&gt;-->
        <!--                        &lt;!&ndash;                <v-text-field label="Seartch input" v-model="serverParams.search"></v-text-field>&ndash;&gt;-->
        <!--                        &lt;!&ndash;              </v-col>&ndash;&gt;-->
        <!--                        &lt;!&ndash;            </v-row>&ndash;&gt;-->
        <!--                        &lt;!&ndash;            <v-row align="center" justify="center">&ndash;&gt;-->
        <!--                        &lt;!&ndash;              <v-btn color="primary" dark @click="searchInput">&ndash;&gt;-->
        <!--                        &lt;!&ndash;                <i class="material-icons">search</i>Search&ndash;&gt;-->
        <!--                        &lt;!&ndash;              </v-btn>&ndash;&gt;-->
        <!--                        &lt;!&ndash;            </v-row>&ndash;&gt;-->
        <!--                    </v-container>-->
        <!--                </v-expansion-panel-content>-->
        <!--            </v-expansion-panel>-->
        <!--        </v-expansion-panels>-->

        <vue-good-table
                :columns="columns"
                :isLoading.sync="isLoading"
                :pagination-options="{ enabled: true, perPageDropdown: [50, 100,200]}"
                :rows="rows"
                :totalRows="totalRecords"
                @on-column-filter="onColumnFilter"
                @on-page-change="onPageChange"
                @on-per-page-change="onPerPageChange"
                @on-sort-change="onSortChange"
                mode="remote"
        >
            <template slot="table-row" slot-scope="props">
        <span v-if="props.column.field == 'actions'">
          <v-icon @click="editItem(props.row)" class="mr-2" small>edit</v-icon>
          <v-icon @click="deleteItem(props.row)" small>delete</v-icon>
        </span>
            </template>
        </vue-good-table>
    </div>
</template>

<script>
    import axios from "axios";
    import buyingRateForm from "./create";
    import editbuyingRateForm from "./edit";
    import deleteListData from "@/components/deleteModal";

    export default {
        name: "BuyingRate",
        components: {
            buyingRateForm,
            editbuyingRateForm,
            deleteListData
        },
        data() {
            return {
                callbackResponse: {
                    timeout: 6000
                },
                snackbar: false,
                success: false,
                dialogCreate: false,
                dialogEdit: false,
                dialogDelete: false,
                deleteFormData: {},
                popout: true,
                isLoading: false,
                columns: [
                    {
                        label: "S No.",
                        field: "countIndex"
                    },
                    {
                        label: "From Currency",
                        field: "fromCurrency"
                    },
                    {
                        label: "To Currency",
                        field: "toCurrency"
                    },
                    {
                        label: "Buying Rate",
                        field: "buyingRate"
                    },
                    {
                        label: "Actions",
                        field: "actions",
                        sortable: false
                    }
                ],
                rows: [],
                totalRecords: 0,
                serverParams: {
                    search: "",
                    columnFilters: {},
                    sort: [
                        {
                            field: "buyingRateID",
                            type: "asc"
                        }
                    ],
                    page: 1,
                    perPage: 10
                },
                user: [],
                editedIndex: -1,
                editedData: {
                    serviceID: "",
                    serviceName: "",
                    serviceDescription: ""
                }
            };
        },

        mounted() {
            this.loadItems();
        },
        methods: {
            onResponse(data) {
                if (data.message) {
                    (this.dialogDelete = false), (this.dialogCreate = false);
                    this.dialogEdit = false;
                    this.callbackResponse = data;
                    this.snackbar = true
                    this.loadItems();
                } else {
                    this.dialogCreate = false;
                    this.dialogEdit = false;
                    this.dialogDelete = false
                }
            },
            editItem(props) {
                this.editedData.serviceID = props.buyingRateID;
                this.dialogEdit = true;
            },
            deleteItem(props) {
                this.dialogDelete = true;
                this.deleteFormData.url = "MoneyExchange/DeleteBuyingExchangeRateAsync/" + props.buyingRateID;
            },
            close() {
                this.dialog = false;
                setTimeout(() => {
                    this.editedData = {}
                    this.editedIndex = -1;
                }, 300);
            },
            updateParams(newProps) {
                this.serverParams = Object.assign({}, this.serverParams, newProps);
            },
            searchInput() {
                this.loadItems();
            },
            onPageChange(params) {
                this.updateParams({page: params.currentPage});
                this.loadItems();
            },
            onPerPageChange(params) {
                this.updateParams({perPage: params.currentPerPage==-1?this.totalRecords:params.currentPerPage});
                this.loadItems();
            },
            onSortChange(params) {
                this.updateParams({
                    sort: [
                        {
                            type: params[0].type,
                            field: params[0].field
                        }
                    ]
                });
                this.loadItems();
            },
            onColumnFilter(params) {
                this.updateParams(params);
                this.loadItems();
            },
            // load items is what brings back the rows from server
            async loadItems() {
                console.log(this.tokenData);
                // eslint-disable-next-line no-console
                let param = {
                    PageSize: this.serverParams.perPage,
                    PageNo: this.serverParams.page,
                    OrderType: this.serverParams.sort[0].type,
                    OrderBy: this.serverParams.sort[0].field,
                    DivisionName: this.serverParams.search,
                    provinceId: parseInt(this.editedData.provinceId)
                };
                axios.post("MoneyExchange/GetBuyingExchangeRateListAsync", param)
                    .then(response => {
                        this.rows = response.data.data;
                        this.totalRecords = response.data.totalCount;
                    })
                    .catch(err => {
                        console.log(err)
                    });
            }
        }
    };
</script>

<style lang="scss" scoped>
    .v-item-group {
        background: #d2e3ff73;
    }

    .v-expansion-panel-header {
        background: #d2e3ff73;
    }

    button {
        z-index: 1;
    }
</style>
